import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import swal from "sweetalert";
// import Header from '../../../components/Header'; // Uncomment jika dibutuhkan
import IconWhatsapp from '../../../local-assets/icon-whatsapp.png';
import IconEmail from '../../../local-assets/icon-email.png';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
// Hapus IconSearch dari import jika ingin menggunakan SVG bawaan yang lebih fleksibel warnanya

const List = () => {
  // --- STATES ---
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [category, setCategory] = useState([]);
  const renderAfterCalled = useRef(false);

  // State untuk UI
  const [tabType, setTabType] = useState("mall");
  const [activeCategory, setActiveCategory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedFaq, setExpandedFaq] = useState(null);
  
  // State Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8; // Jumlah item per halaman

  // --- FETCH DATA ---
  useEffect(() => {
    if (!renderAfterCalled.current) {
      getData();
      getCategory();
    }
    renderAfterCalled.current = true;
  }, []);

  useEffect(() => {
    // Reset data state saat loading (opsional tapi disarankan agar UI bersih saat ganti tab)
    setData([]);
    setCategory([]);

    if (tabType === "mall") {
      getData();
      getCategory();
    } else if (tabType === "home") {
      getDataHome();
      getCategoryHome();
    }
  }, [tabType]);

  const getData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}mall/faq`);
      setData(response.data);
    } catch (error) {
      swal("Maaf", "Terjadi Kesalahan, mohon refresh ulang.", "warning");
    }
  };

  const getCategory = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}mall/category-faq`);
      setCategory(response.data);
      // Set kategori pertama sebagai aktif secara default
      if (response.data.length > 0) {
        setActiveCategory(response.data[0].name);
      }
    } catch (error) {
      swal("Maaf", "Terjadi Kesalahan, mohon refresh ulang.", "warning");
    }
  };

  const getDataHome = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}home/faq`);
      setData(response.data);
    } catch (error) {
      swal("Maaf", "Terjadi Kesalahan, mohon refresh ulang.", "warning");
    }
  };

  const getCategoryHome = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}home/category-faq`);
      setCategory(response.data);
      // Set kategori pertama sebagai aktif secara default
      if (response.data.length > 0) {
        setActiveCategory(response.data[0].name);
      }
    } catch (error) {
      swal("Maaf", "Terjadi Kesalahan, mohon refresh ulang.", "warning");
    }
  };

  // --- FILTER & PENCARIAN (Client Side) ---
  // 1. Ambil data FAQ berdasarkan kategori yang sedang aktif
  const currentCategoryData = category.find(c => c.name === activeCategory);
  let filteredFaqs = currentCategoryData ? currentCategoryData.faq : [];

  // 2. Jika ada teks di kolom search, saring datanya
  if (searchQuery.trim() !== "") {
    filteredFaqs = filteredFaqs.filter(faq => 
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) || 
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  // --- PAGINATION LOGIC ---
  const totalPages = Math.ceil(filteredFaqs.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentDisplayedFaqs = filteredFaqs.slice(startIndex, startIndex + itemsPerPage);

  // Reset pagination & expanded FAQ saat mengganti tab/kategori/search
  useEffect(() => {
    setCurrentPage(1);
    setExpandedFaq(null);
  }, [activeCategory, searchQuery, tabType]);

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  const formatToSlug = (text) => {
    if (!text) return "";

    return text
      .trim()
      .toLowerCase()
    .replace(/\s+/g, '-');
} ;

  return (
    <section className="bg-white py-10 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* HEADER & SEARCH SECTION */}
        <div className="mb-8">
          <h3 className="text-2xl md:text-3xl font-bold text-[#101828] mb-2">
            Punya pertanyaan ? cari jawaban pertanyaan Anda disini
          </h3>
          <p className="text-[#475467] text-sm md:text-base mb-6">
            Cari pertanyaan melalui search box atau melalui kategori pertanyaan yang disediakan
          </p>

          {/* Input Search */}
          <div className="relative max-w-full mb-6">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Cari pertanyaanmu disini..."
              className="w-full pl-11 pr-4 py-3 rounded-xl border border-gray-200 bg-[#F9FAFB] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#F36F21]/20 focus:border-[#F36F21] transition-colors text-[#101828] text-sm md:text-base placeholder-gray-400"
            />
          </div>

          {/* TOGGLE APPS (Mall vs Home) */}
          {/* 1. Tambahkan div pembungkus ini agar bisa di-scroll */}
          <div className="w-full overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            
            {/* 2. Ubah w-fit menjadi w-max di sini */}
            <div className="inline-flex bg-[#F2F4F7] p-1 rounded-xl w-max">
              <Link
                onClick={() => setTabType("mall")}
                // 3. Tambahkan flex-shrink-0 di sini
                className={`flex-shrink-0 px-6 py-2.5 rounded-lg transition-all duration-200 ${
                  tabType === "mall" 
                    ? "bg-[#F36F21] text-white shadow-sm" 
                    : "text-[#475467] hover:text-[#101828]"
                }`}
              >
                <span className="text-sm font-semibold whitespace-nowrap">
                  Summarecon Mall Apps
                </span>
              </Link>

              <Link
                onClick={() => setTabType("home")}
                // 3. Tambahkan flex-shrink-0 di sini juga
                className={`flex-shrink-0 px-6 py-2.5 rounded-lg transition-all duration-200 ${
                  tabType === "home" 
                    ? "bg-[#F36F21] text-white shadow-sm" 
                    : "text-[#475467] hover:text-[#101828]"
                }`}
              >
                <span className="text-sm font-semibold whitespace-nowrap">
                  Summarecon Home Apps
                </span>
              </Link>
            </div>

          </div>
        </div>

        {/* CATEGORY TABS (Scrollable di Mobile) */}
        <div className="border-b border-gray-200 mb-2">
          <nav className="flex space-x-6 md:space-x-8 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            {category.map((cat, index) => (
              <Link
                key={index}
                onClick={() => setActiveCategory(cat.name)}
                className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm md:text-base transition-colors ${
                  activeCategory === cat.name
                    ? "border-[#F36F21] text-[#F36F21]"
                    : "border-transparent text-[#475467] hover:text-[#101828] hover:border-gray-300"
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </nav>
        </div>

        {/* FAQ ACCORDION LIST */}
        <div className="mb-10 min-h-[400px]">
          {currentDisplayedFaqs.length > 0 ? (
            currentDisplayedFaqs.map((faq, index) => (
              <div key={index} className="border-b border-gray-100">
                <Link
                  to={`/v2/faq/detail/${formatToSlug(faq?.question)}`}
                  state={{ faqData: faq }}
                  className="w-full flex justify-between items-center py-5 text-left focus:outline-none group"
                >
                  <span className="text-sm md:text-base font-medium text-[#101828] pr-4 group-hover:text-[#F36F21] transition-colors">
                    {faq.question}
                  </span>
                  <svg 
                    className={`w-5 h-5 text-gray-400 transform transition-transform duration-200 flex-shrink-0 ${expandedFaq === index ? "rotate-90" : ""}`} 
                    fill="none" viewBox="0 0 24 24" stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
                
                {/* Isi Jawaban (Animasi Expand) */}
                <div 
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    expandedFaq === index ? "max-h-[500px] opacity-100 pb-5" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="text-sm md:text-base text-[#475467] leading-relaxed pr-8">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="py-10 text-center text-gray-500">
              Tidak ada pertanyaan yang cocok dengan pencarian Anda.
            </div>
          )}
        </div>

        {/* PAGINATION */}
        {totalPages > 1 && (
          <div className="flex items-center justify-between border-t border-gray-200 pt-6 mb-12">
            <Link
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="flex items-center text-sm font-medium text-[#475467] hover:text-[#101828] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg className="mr-2 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
              <span className="hidden md:inline">Previous</span>
            </Link>

            {/* Mobile Pagination Text */}
            <span className="text-sm text-[#475467] md:hidden">
              Page {currentPage} of {totalPages}
            </span>

            {/* Desktop Pagination Numbers */}
            <div className="hidden md:flex space-x-2">
              {[...Array(totalPages)].map((_, i) => (
                <Link
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                  className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-medium transition-colors ${
                    currentPage === i + 1
                      ? "bg-gray-100 text-[#101828]"
                      : "text-[#475467] hover:bg-gray-50"
                  }`}
                >
                  {i + 1}
                </Link>
              ))}
            </div>

            <Link
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="flex items-center text-sm font-medium text-[#475467] hover:text-[#101828] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span className="hidden md:inline">Next</span>
              <svg className="ml-2 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        )}

        {/* CONTACT BOX SECTION */}
        <div className="bg-[#F9FAFB] border border-gray-200 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <div className="text-left">
            <h4 className="text-base md:text-lg font-bold text-[#101828] mb-1">
              Masih belum menemukan jawaban pertanyaan Anda?
            </h4>
            <p className="text-sm text-[#475467]">
              Hubungi kami melalui Email atau whatsapp
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row w-full md:w-auto gap-3">
            <a 
              href='https://api.whatsapp.com/send?phone=6282113111610&text=Halo,%20saya%20ingin%20bertanya'
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto flex items-center justify-center px-6 py-3 bg-[#F36F21] text-white rounded-lg text-sm font-medium hover:bg-[#E65C00] transition-colors"
            >
              <img src={IconWhatsapp} alt="WhatsApp" className="w-5 h-5 mr-2 object-contain" />
              Chat Whatsapp
            </a>
            <a 
              href="mailto:csapps@summarecon.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto flex items-center justify-center px-6 py-3 bg-[#F36F21] text-white rounded-lg text-sm font-medium hover:bg-[#E65C00] transition-colors"
            >
              <img src={IconEmail} alt="Email" className="w-5 h-5 mr-2 object-contain" />
              Kirim Email
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default List;